<template>
	<cm-lightbox v-if="lightboxDocumentVisible" @lgbcancel="onCancel">
		<template v-slot:header>{{ lightbox.header }}</template>

		<template v-slot:body>
			<div class="lightbox__block" v-for="(block, index) in lightbox.body" :key="index" :data-kind="block.kind">
				<div class="lightbox__subblock">
					<div class="lightbox__title">{{ block.title }}</div>

					<cm-input
						:type="'text'"
						:name="block.name"
						:value="this.name || block.value"
						:status="this.name ? 'valid' : block.status"
						:disabled="block.disabled"
						@input="onChange($event, 'input')"
						@paste="onChange($event, 'input')"
						@change="onChange($event, 'input')"
						@blur="onChange($event, 'input')"
					/>

					<span v-if="block.error" class="lightbox__error">{{ block.error }}</span>
				</div>

				<cm-file @iflchange="onChange($event, 'file')" />
			</div>
		</template>

		<template v-slot:footer>
			<cm-button
				type="text"
				value="Добавить документ"
				paint="blue"
				action="addDocument"
				:disabled="!validation"
				@click="onApply"
			/>
		</template>
	</cm-lightbox>
</template>

<script>
	import { mapGetters, mapMutations, mapActions } from "vuex";

	import Lightbox from "../appearance/Lightbox.vue";
	import Button from "../components/Button.vue";
	import File from "../components/File.vue";
	import Input from "../components/Input.vue";

	export default {
		components: {
			"cm-button": Button,
			"cm-file": File,
			"cm-input": Input,
			"cm-lightbox": Lightbox,
		},
		data() {
			return {
				lightbox: null,
				name: null,
				file: null,
				prev: null,
				validation: false,
			};
		},
		computed: {
			...mapGetters({
				lightboxDocumentVisible: "lightboxDocumentVisible",
			}),
			state() {
				return this.$store.state;
			},
		},
		methods: {
			...mapMutations(["showLightboxDocument"]),
			...mapActions(["addSystemDocument"]),

			/* INIT FUNCTIONS */
			initLightbox() {
				this.lightbox = {
					header: "Добавление документа",
					body: [
						{
							id: 0,
							kind: "file",
							name: "name",
							title: "Название документа",
							value: null,
							status: "default",
							error: false,
						},
					],
				};
			},

			/* SPECIAL HANDLERS */
			nandleInput(payload) {
				let input = this.lightbox.body[0];

				if (input) {
					input.value = payload.value;
					this.name = payload.value;

					if (payload.value.match(this.state.common.patterns[payload.name])) {
						input.status = "valid";
						input.error = null;
					} else {
						input.status = "invalid";
						input.error = this.state.common.errors[payload.name];
					}
				}
			},
			handleFile(payload) {
				if (!payload.file) return;

				this.file = payload.file;

				if (!this.name) {
					this.name = payload.file.name.replace(/\.[^/.]+$/, "");
					this.prev = payload.file;
				} else if (this.name && this.prev) {
					this.name = null;
					this.name = payload.file.name.replace(/\.[^/.]+$/, "");
				}
			},
			checkValidation() {
				if (this.lightbox.body?.length) {
					this.validation = this.name && this.file;
				}
			},

			/* EVENT HANDLERS */
			onChange(event, source) {
				let payload = null;

				if (source === "input") {
					payload = {
						name: event.target.name,
						value: event.target.value,
						event: event.type,
					};

					this.nandleInput(payload);
				}

				if (source === "file") {
					payload = {
						file: event.target.files[0],
					};

					this.handleFile(payload);
				}

				this.checkValidation();
			},
			onCancel() {
				this.showLightboxDocument(false);
				this.onReset();
			},
			onApply() {
				let payload = {
					name: this.name,
					file: this.file,
				};

				this.addSystemDocument(payload);
				this.showLightboxDocument(false);
				this.onReset();
			},
			onReset() {
				if (this.lightbox.body?.length) {
					this.lightbox.body.forEach((element) => {
						element.value = null;
						element.status = "default";
						element.error = false;
					});
				}

				this.name = null;
				this.file = null;
				this.prev = null;
				this.validation = false;
			},
		},
		created() {
			this.initLightbox();
		},
	};
</script>

<style lang="scss" scoped></style>
